<mat-icon *ngIf="code.includes('text:') === false">{{code}}</mat-icon>
<div *ngIf="code.includes('text:') === true" class="work-status-icon__text-icon">{{code.replace('text:', '')}}</div>